const Footer = () => {
    return (
        <footer className="footer">

            <div className="container">

                <div className="footer-bottom">

                    <div className="footer-social">

                        <a href="https://www.facebook.com/justcreativeid/" target="_blank" aria-label="Facebook">
                            <i className="bi bi-facebook"></i>
                        </a>

                        <a href="https://www.instagram.com/justcreativeid?igsh=MXdwOTl4OWNheWxieA==" target="_blank" aria-label="Instagram">
                            <i className="bi bi-instagram"></i>
                        </a>

                        <a href="https://youtube.com/@justcreativejalore9877?si=UjYThsirSl8kbITg" target="_blank" aria-label="YouTube">
                            <i className="bi bi-youtube"></i>
                        </a>

                    </div>

                    <p className="copyright">
                        © {new Date().getFullYear()} ITHE Card Solutions. All Rights Reserved.
                    </p>

                </div>

            </div>

        </footer>
    );
};

export default Footer;